import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ProductVariantPageRBAC = {
  pageID: '6b7b2c674c8d4909c4035c96d0f24c43',
  elementID: {
    ButtonAddVariant: '0678c6b9703f51cea223cb39e21b77cd',
    ButtonEditVariant: '1e2c1fd1d596b70d4edec4c8bdd637cd',
    ButtonDeleteVariant: 'e969d1a9a7733d600c1c231f5f004722',
  },
} as const

export const useRBACProductVariantPage = createUseRBAC(ProductVariantPageRBAC.elementID)

export type UseRBACProductVariantPageType = ReturnType<typeof useRBACProductVariantPage>
